import React from "react";
import { useTranslation } from "react-i18next";

const AdminTable = (props) => {
  const { t } = useTranslation();
  return (
    <div className="table-wrapper px-3 pt-3">
      <p className="table-type">{t("admin.admins.table.allAdmin")}</p>
      <div className="table-wrapper-scroll-y table-scrollbar">
        <div className="table-responsive table-own">
          <table className="table table-striped table-hover table-admin">
            <thead className="table-head">
              <tr>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "firstName" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("firstName")}
                >
                  <span>{t("admin.admins.table.firstName")}</span>
                  {/* <img
                    src="/assets/img/arrow-side.svg"
                    className="sort-icon"
                    alt="icon"
                  /> */}
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "lastName" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("lastName")}
                >
                  <span>{t("admin.admins.table.lastName")} </span>
                  {/* <img
                    src="/assets/img/arrow-side.svg"
                    className="sort-icon"
                    alt="icon"
                  /> */}
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "email" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("email")}
                >
                  <span>{t("admin.admins.table.email")}</span>

                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th className={`sort-header cursor ${props?.sortObj?.sortVal === "isActivated" ? "active" : ""
                  } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("isActivated")}>{t("common.status")}
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}</th>
                <th>{t("common.actions")}</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {props.dataList.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{data?.firstName}</td>
                    <td>{data?.lastName}</td>
                    <td>{data?.email}</td>
                    <td className="table-data-status">
                      {data?.isActivated && data.isPublished ? (
                        <span className="table-isactive">{t("common.active")}</span>
                      ) : (
                        <span className="table-isinactive">{t("common.inactive")}</span>
                      )}
                    </td>
                    <td className="nowrap">
                      <button
                        disabled={!data?.isActivated}
                        onClick={() => props?.toggleUser(data)}
                        className="mr-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                      >
                        {!(data?.isActivated && data.isPublished)
                          ? t("common.active")
                          : t("common.inactive")}
                      </button>{" "}
                      |{" "}
                      <span
                        onClick={() =>
                          data?.isActivated
                            ? props?.resetUser(data)
                            : props?.resendUser(data)
                        }
                        className="ml-1 btn btn-own-admin primary-btn min-btn-xl btn-sm-own table-action"
                      >
                        {data?.isActivated
                          ? t("common.resetPassword")
                          : t("common.resendActivationMail")}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminTable;
